import './FavoriteInfo.scss'

import React from 'react'

import { translated } from '../_translation'

/**
 * @param {Object} props
 * @param {boolean} [props.isFavorite]
 * @param {number} props.favoriteCount
 * @param {React.MouseEventHandler<HTMLButtonElement>} [props.onClick]
 */
const FavoriteInfo = ({ gettext, isFavorite, favoriteCount, onClick }) => {
    const btnTooltip = onClick && (isFavorite ? gettext('Remove from favorites') : gettext('Add to favorites'))

    const icon = (
        <i className={(isFavorite ? 'i-heart' : 'i-heart-empty') + ' text-primary'} />
    )

    let classes = 'favorite-info'
    if (isFavorite) classes += ' is-favorite'

    return (
        <div className={classes}>
            {onClick ? (
                <button
                    onClick={(isFavorite !== null) ? onClick : null}
                    className="bm-tooltip-left"
                    aria-label={btnTooltip}
                    data-tooltip={btnTooltip}
                    data-testid="favorite-info-action-button"
                >
                    {icon}
                </button>
            ) : icon}
            <div className="favorite-count">{favoriteCount}</div>
        </div>
    )
}

export default translated(FavoriteInfo)
